import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

export const defaultState = {
	query: "",
	filter: "Search Everything",
	selectedTimeFrame: [null, null],
	selectedTimeValue: "",
	sessionSearchValues: [],
};

const QUICK_SEARCH_UPDATE_QUERY = (state, action) => {
	const { query } = action;
	return {
		...state,
		query: query,
	};
};

const QUICK_SEARCH_UPDATE_FILTER = (state, action) => {
	const { filter } = action;
	return {
		...state,
		filter: filter,
	};
};

const QUICK_SEARCH_UPDATE_SELECTED_TIME_FRAME = (state, action) => {
	const { selectedTimeFrame } = action;
	return {
		...state,
		selectedTimeFrame: selectedTimeFrame,
	};
};

const QUICK_SEARCH_UPDATE_SELECTED_TIME_VALUE = (state, action) => {
	const { selectedTimeValue } = action;
	return {
		...state,
		selectedTimeValue: selectedTimeValue,
	};
};
const QUICK_SEARCH_UPDATE_SESSION_SEARCH_VALUES = (state, action) => {
	const { sessionSearchValues } = action;
	return {
		...state,
		sessionSearchValues: sessionSearchValues,
	};
};

const handlers = {};
handlers[actionTypes.QUICK_SEARCH_UPDATE_QUERY] = QUICK_SEARCH_UPDATE_QUERY;
handlers[actionTypes.QUICK_SEARCH_UPDATE_FILTER] = QUICK_SEARCH_UPDATE_FILTER;
handlers[
	actionTypes.QUICK_SEARCH_UPDATE_SELECTED_TIME_FRAME
] = QUICK_SEARCH_UPDATE_SELECTED_TIME_FRAME;
handlers[
	actionTypes.QUICK_SEARCH_UPDATE_SELECTED_TIME_VALUE
] = QUICK_SEARCH_UPDATE_SELECTED_TIME_VALUE;
handlers[
	actionTypes.QUICK_SEARCH_UPDATE_SESSION_SEARCH_VALUES
] = QUICK_SEARCH_UPDATE_SESSION_SEARCH_VALUES;
export default createReducer(defaultState, handlers);
